/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/ChallengeAuthorities/PlayCardDailyPyramidAuthority',[
    'SolitaireShared/PyramidLogic/PyramidAuthority',
    'SolitaireShared/PyramidLogic/IDailyPyramidAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/IPlayCardDailyAuthority',
    'SolitaireShared/CardLogic/CardOp'
], function (PyramidAuthority, IDailyPyramidAuthority, IDailyAuthority, IPlayCardDailyAuthority, CardOp) {
    "use strict";

    var PlayCardDailyPyramidAuthority = function (param) {
        this.initPlayCardDailyPyramidAuthority(param);
    };

    PlayCardDailyPyramidAuthority.constructor = PlayCardDailyPyramidAuthority;
    PlayCardDailyPyramidAuthority.prototype = Object.create(IDailyPyramidAuthority.prototype);
    IPlayCardDailyAuthority.call(PlayCardDailyPyramidAuthority.prototype);

    Object.defineProperty(PlayCardDailyPyramidAuthority.prototype, "NumberPlayed",  {
        get: function () {
            return this._goalCompleted ? 1 : 0;
        }
    });

    PlayCardDailyPyramidAuthority.KeyCardToPlay =  "CARDTOPLAY";

    /// <summary>
    /// Constructs a daily challenge authority which implements the win condition "Play card x to foundation"
    /// </summary>
    /// <param name="param">String value of card which must be played</param>
    PlayCardDailyPyramidAuthority.prototype.initPlayCardDailyPyramidAuthority = function (param) {
        IDailyPyramidAuthority.call(this);
        this.SuppressBonusAnimations = true;

        if (param != null && param[PlayCardDailyPyramidAuthority.KeyCardToPlay])
            this._cardToPlay = this.GetCardValue(param[PlayCardDailyPyramidAuthority.KeyCardToPlay].toUpperCase());
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayCard;
        this._goalCompleted = false;
    };

    PlayCardDailyPyramidAuthority.prototype.Deal = function () {
        this._goalCompleted = false;

        return IDailyPyramidAuthority.prototype.Deal.call(this);
    };

    PlayCardDailyPyramidAuthority.prototype.GetScoreForAction = function (action)
    {
        var botherChecking = false;
        for (var i = 0; i < action.Ops.length; i++)
        {
            var op = action.Ops[i];
            var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
            if (op.Opcode == CardOp.Op.Move && destPile.Type == "Foundation" && !destPile.Empty)
            {
                botherChecking = true;
                break;
            }
        }

        if (botherChecking)
        {
            var cards = this.CardSupply.GetPile("Foundation").GetCards();
            for (var ci = 0; ci < cards.length; ci++)
            {
                var card = cards[ci];
                if (card.ToString() == (this._cardToPlay))
                {
                    this._goalCompleted = true;
                    break;
                }
            }
        }

        return IDailyPyramidAuthority.prototype.GetScoreForAction.call(this, action);
    };

    PlayCardDailyPyramidAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.IsWaitingForAds)
        {
            return false;
        }

        this.CardSupply.GetPile("Foundation");
        return (!this.CardSupply.WaitingForAnimation) && this._goalCompleted;
    };

    PlayCardDailyPyramidAuthority.prototype.GetHint = function (cycle, cheat)
    {

        if(cheat) {
            return IDailyPyramidAuthority.prototype.GetHint.call(this,cycle,cheat);
        }

        cycle = !!cycle;
        var numTableaus = 28;
        var hints = [];

        var crrntPile;
        this.CardSupply.GetPile("Foundation");
        var cards = ["CHALLENGE"];
        for (var i = numTableaus - 1; i >= 0; i--)
        {
            crrntPile = this.CardSupply.GetPile("Tableau" + i);
            if (crrntPile.Empty)
                continue;
            if (crrntPile.Top.ToString() == (this._cardToPlay))
            {
                cards.push(crrntPile.Top.Sequence.toString());
                break;
            }
        }
        crrntPile = this.CardSupply.GetPile("Stock");
        if (!crrntPile.Empty && crrntPile.Top.ToString() == (this._cardToPlay))
        {
            cards.push(crrntPile.Top.Sequence.toString());
        }
        crrntPile = this.CardSupply.GetPile("Waste");
        if (!crrntPile.Empty && crrntPile.Top.ToString() == (this._cardToPlay))
        {
            cards.Add(crrntPile.Top.Sequence.toString());
        }
        if (cards.Count > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };
/*

    PlayCardDailyPyramidAuthority.prototype.GetCardValue = function (card)
    {
        var value = parseInt(card.substring(0, 2));

        if (!isNaN(value))
        {
            return "T" + card[card.length - 1];
        }
        return card;
    };
*/

    PlayCardDailyPyramidAuthority.prototype.GetCardValue = function (card)
    {
        return card;
    };



    return PlayCardDailyPyramidAuthority;

});
